import React from 'react';
import './Service.css';
import { GiHiveMind } from 'react-icons/gi';
import { LiaDigitalTachographSolid } from 'react-icons/lia';
import { FaCloud } from 'react-icons/fa';
import { MdOutlineIntegrationInstructions, MdManageHistory } from 'react-icons/md';
import { GrVmMaintenance } from 'react-icons/gr';

export const Service = () => {
  const services = [
    {
      icon: <GiHiveMind />,
      title: 'Artificial Intelligence',
      description: 'Leverage AI and machine learning to automate processes, gain insights, and drive smarter business decisions across your organization.'
    },
    {
      icon: <LiaDigitalTachographSolid />,
      title: 'Digital Experience Platform',
      description: 'Create seamless, personalized digital experiences for your customers across every touchpoint and channel.'
    },
    {
      icon: <FaCloud />,
      title: 'Cloud & DevOps',
      description: 'Migrate to the cloud and streamline your development pipeline with modern infrastructure and continuous delivery practices.'
    },
    {
      icon: <MdOutlineIntegrationInstructions />,
      title: 'Software Development & Integration',
      description: 'Build custom software solutions and integrate disparate systems to create unified, efficient workflows.'
    },
    {
      icon: <MdManageHistory />,
      title: 'Project Management',
      description: 'Expert project oversight ensuring timely delivery, resource optimization, and alignment with your business objectives.'
    },
    {
      icon: <GrVmMaintenance />,
      title: 'Data & Analytics',
      description: 'Transform raw data into actionable intelligence with modern analytics platforms and data engineering solutions.'
    }
  ];

  const reasons = [
    {
      title: 'Expertise',
      description: 'Deep technical knowledge across modern platforms and methodologies, backed by industry certifications.'
    },
    {
      title: 'Custom Solutions',
      description: 'Tailored approaches designed specifically for your unique challenges and business requirements.'
    },
    {
      title: 'Customer-Centric Approach',
      description: 'Your success is our priority. We collaborate closely to ensure solutions align with your vision.'
    },
    {
      title: 'Cutting-Edge Technology',
      description: 'We stay ahead of the curve, leveraging the latest tools and frameworks for optimal results.'
    }
  ];

  return (
    <div className="service-page">
      {/* Hero */}
      <section className="service-hero">
        <div className="container">
          <span className="badge">Our Services</span>
          <h1>IT Services Built for Growth</h1>
          <p>
            We prioritize understanding your unique challenges and goals, ensuring that
            our solutions are technically sound and aligned with your business objectives.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="card service-detail-card">
                <div className="service-detail-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <span className="badge">Differentiators</span>
            <h2>Why Choose Us?</h2>
          </div>
          <div className="reasons-grid">
            {reasons.map((reason, index) => (
              <div key={index} className="reason-card">
                <div className="reason-number">{String(index + 1).padStart(2, '0')}</div>
                <h3>{reason.title}</h3>
                <p>{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
